import React, { useContext } from 'react';
import strings from 'common/strings';
import VehicleCardSkeleton from './VehicleCardSkeleton';
import { VehicleCardContext } from '../VehicleCard';

interface VehicleCardYearMakeModelProps {
  size: 'wide' | 'medium' | 'small' | 'mobile';
}

var VehicleCardYearMakeModel = ({ size }: VehicleCardYearMakeModelProps) => {
  const { vehicle } = useContext(VehicleCardContext);
  const { year, make, model } = vehicle?.vehicleCard ?? {};
  if (size === 'wide' || size === 'medium') {
    return (
      <VehicleCardSkeleton renderSkeleton={!vehicle}>
        <div className="Vehicle-card-year-make-model">
          {vehicle && (year || make)
            ? `${year || ''} ${make || ''} ${model || ''}`
            : strings.EMPTY_VALUE}
        </div>
      </VehicleCardSkeleton>
    );
  }

  return (
    <VehicleCardSkeleton renderSkeleton={!vehicle}>
      <div className="VehicleCard-year-make-model-container">
        <div className="Vehicle-card-year-make-model">
          {vehicle && (year || make)
            ? `${year || ''} ${make || ''}`
            : strings.EMPTY_VALUE}
        </div>
        <div className="VehicleCard-model">{model || ''}</div>
      </div>
    </VehicleCardSkeleton>
  );
};

export default VehicleCardYearMakeModel;
